module.exports = __webpack_public_path__ + "img/learnReason4.9cbd6c70.png";